import { useState, useEffect } from "react";

import {
  CardMedia,
  Divider,
  Grid,
  Box,
  Container,
  Typography,
  Card,
} from "@mui/material";
import _ from "lodash";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from "components/Loader";
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { useSelector } from "react-redux";
import BannerCarousel from "views/Landing/BannerCarousel";
import PrimaryButton from "components/Button";
import { useNavigate } from "react-router-dom";
const About = ({ breadcrumbs }) => {
  var navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [aboutUs, setAboutUs] = useState();
  const webDetails = useSelector((state) => state.webDetails);
  const { websiteInfo } = webDetails;
  console.log("aboutus", websiteInfo["about_us_images"]);
  const getAboutUs = async () => {
    setLoader(true);
    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.ABOUT_INFO);
    let { data, response } = res;

    if (data && data.about) {
      setAboutUs(data.about);
    }
    setLoader(false);
  };

  useEffect(() => {
    getAboutUs();
  }, []);

  const bgImage = require("../../assets/images/background.jpg");

  return (
    <CustomLayout>
      <Loader open={loader} />
      {/* <div
                style={{ 
                    // backgroundImage: `url(${_.get(websiteInfo, 'banner')})` 
                    backgroundImage: _.get(websiteInfo, 'banner', '') 
                        ? `url(${_.get(websiteInfo, 'banner')})`
                        : `url(${bgImage})`
                }}
                class="parallax">
                <div className="header-wrapper">
                    <span className="span-2">About Us</span>
                </div>
            </div> */}

      <>
        {/* ✅ Desktop View */}
        {/* <Box
        className="parallax"
        sx={{
          display: { xs: "none", sm: "none", md: "block" },
          backgroundImage: _.get(websiteInfo, "banner", "")
            ? `url(${_.get(websiteInfo, "banner")})`
            : `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="header-wrapper">
          <span className="span-2">About Us</span>
        </div>
      </Box> */}

        {/* ✅ Mobile View */}
        {/* <Box
        sx={{
          display: { xs: "block", sm: "block", md: "none" },
          position: "relative",
        }}
      >
        <img
          src={
            _.get(websiteInfo, "banner", "")
              ? _.get(websiteInfo, "banner")
              : bgImage
          }
          alt="Banner"
          style={{ width: "100%", height: "auto", objectFit: "cover" }}
        />
        <div
          className="header-wrapper"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "white",
          }}
        >
          <span className="span-2">About Us</span>
        </div>
      </Box> */}
        <BannerCarousel type={"about"} />
      </>
      <Container maxWidth="lg" disableGutters sx={{ mb: 10 }}>
        <Box
          className="content-container"
          sx={{
            maxWidth: "1250px",
            width: "100%",
            margin: "0 auto",
            px: { xs: 2, sm: 2, md: 3 },
          }}
        >
          <Box sx={{ mt: 3, mb: 3 }}>
            {" "}
            {/* <CustomBreadcrumbs list={breadcrumbs} name={"About"} /> */}
            {/* <Divider className="divider" sx={{ mt: 3 }} /> */}
            <h4
              style={{
                fontSize: "clamp(20px, 4vw, 42px)",
                fontWeight: 700,
                lineHeight: 1,
                letterSpacing: "-1px",
              }}
            >
              Welcome to {webDetails?.websiteInfo?.store_name}
            </h4>
            <Box sx={{ mt: 2 }}>
              <PrimaryButton
                minWidth={180}
                endIcon={<ArrowForwardIcon />}
                onClick={() => navigate("/products")}
              >
                Start Shoping Now
              </PrimaryButton>
            </Box>
          </Box>
          <Grid container className="about-wrapper main-content-wrapper">
            <Grid
              container
              spacing={3}
              justifyContent="space-between"
              alignItems="stretch"
            >
             
              <Grid item xs={12} sm={12} md={12} lg={websiteInfo?.about_main_image ? 6 : 12}>
                <Box
                  sx={{
                    // height: { xs: "auto", sm: "auto", md: "420px", lg: "500px" },
                    // height: { xs: "auto", md: "400px", lg: "500px" }, // same height as image
                    width: "100%",
                    overflowY: "auto",
                    p: { xs: 1, md: 2 },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "var(--fs-sm)",
                      color: "#333",
                    }}
                    dangerouslySetInnerHTML={{ __html: aboutUs }}
                  />
                </Box>
              </Grid>
              {/* IMAGE BOX */}
              {websiteInfo?.about_main_image && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Box
                    sx={{
                      borderRadius: "10px",
                      overflow: "hidden",
                      width: "100%",
                      height: { xs: "auto", sm: "auto", md: "420px", lg: "500px" },
                    }}
                  >
                    <Box
                      component="img"
                      src={websiteInfo?.about_main_image}
                      alt="About Us"
                      sx={{
                        width: "100%",
                        display: "block",
                        height: { xs: "auto", sm: "auto", md: "100%", lg: "100%" },
                        objectFit: { xs: "contain", sm: "contain", md: "contain", lg: "contain" },
                      }}
                    />
                  </Box>
                </Grid>
              )}
              

              {/* TEXT BOX */}
            </Grid>

            <Box
              sx={{
                mt: 6,
                mb: 6,
                display: "flex",
                gap: 2,
                overflowX: "auto",
                overflowY: "hidden",
                paddingBottom: "10px",
                scrollBehavior: "smooth",

                "&::-webkit-scrollbar": {
                  height: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#ccc",
                  borderRadius: "10px",
                },
              }}
            >
              {websiteInfo?.about_us_images?.map((url, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: "0 0 auto",
                    width: {
                      xs: "120px",
                      sm: "100px",
                      md: "180px",
                      lg: "215px",
                    },
                    height: {
                      xs: "90px",
                      sm: "100px",
                      md: "120px",
                      lg: "140px",
                    },
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid rgba(0,0,0,0.08)",
                  }}
                >
                  <img
                    src={url}
                    alt={`Image ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // Bash style
                      display: "block",
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Grid>
        </Box>
      </Container>
    </CustomLayout>
  );
};

export default About;
